<template>
<div class="index page_iteminfo page" v-if="item">
    <div class="top">
        <div class="title" v-if="item">{{ item.title}}</div>
        <div class="tags" v-if="item">
            <div class="tag" v-if="item.level">
                {{ item.level.title }}
            </div>
            <div class="tag" v-if="item.cate">
                {{ item.cate.name }}
            </div>
        </div>
        <div class="from" v-if="item">
            <span v-if="item.area1">{{item.area1.areaname ? item.area1.areaname : ''}}</span>
            <span v-if="item.area2">{{item.area2.areaname ? '>'+item.area2.areaname : ''}}</span>
            <span v-if="item.area3">{{item.area3.areaname ? '>'+item.area3.areaname : ''}}</span>
        </div>
    </div>
    <!-- 具体介绍 -->
    <div class="item relative">
        <p v-html="item.content" class="jieshao"></p>
        <!-- 报错 -->
        <!-- <div class="tips" v-if="show_more">
            以上图文均来源于网络，如有异议请提交报错<span class="baocuo" @click="baocuoFun(dataList.shopid)">报错</span>
        </div> -->
		<!-- 加载更多提示 -->
		<!-- <div :class="!show_more ? 'showmore border' :'showmore'">
			<div class="loadmore" v-if="!show_more" @click="loadMore">
				<div class="gradient"></div>
				<div class="txt">加载更多</div>
			</div>
		</div> -->
    </div>
    <div v-if="item.web_url" class="item_tu single" style="margin-left: 0.3rem;margin-right: 0.3rem;margin-top:0.3rem;margin-bottom:0.3rem;" @click="toNewWeb">
        <van-image style="border-radius:0.134rem" fit="cover" v-if="item.web_thumb" :src="item.web_thumb" class="tu mark" :show-error="false" :show-loading="false" />
    </div>
    <!-- 非遗匠人 -->
    <!-- <div :class="!show_more ? 'jiangren padding' : 'jiangren'" v-if="tradesman">
        <van-swipe :loop="false" class="item">
            <van-swipe-item>
                <div class="con">
                    <div class="con_info clearfix" @click="toTradesman(tradesman.id)">
                        <div class="f-l thumb">
                            <img :src="tradesman.thumb? tradesman.thumb : $publicData.defaultTouxiang" alt="" class="" />
                        </div>
                        <div class="f-l con_info_r">
                            <div class="name">{{ tradesman.nickname }}</div>
                        </div>
                    </div>
                    <div :class="
                dataList.isattention == 1 ? 'guanzhu' : 'guanzhu guanzhu_no'
              " @click="guanzhuFun(dataList.isattention, tradesman.id)">
                        {{ dataList.isattention == 1 ? "已关注" : "关注" }}
                    </div>
                </div>
            </van-swipe-item>
        </van-swipe>
    </div> -->
    <!-- 非遗商品 -->
    <!-- <div class="goods datalist item" v-if="goods">
        <ul class="list">
            <li class="item" v-for="(item, index) in goods" :key="index" @click="goShopDetail(item)">
                <div class="thumb">
                    <van-image class="vanImage" fit="contain" :show-error="false" :show-loading="false" :src="item.thumb ? item.thumb: $publicData.intangibleDefault" />
                </div>
                <div class="item_xinxi">
                    <div class="title_wrap single">
                        <div class="title_tag">
                            <span class="icon_self" v-if="item.goodset.is_self">自营</span>
                            <span class="icon_new" v-if="item.goodset.is_new">最新</span>
                        </div>
                        <span v-if="item.goodset.is_self && item.goodset.is_new" class="title title1 slh_s"> {{ item.title }}</span>
                        <span v-else-if="item.goodset.is_self || item.goodset.is_new" class="title title2 slh_s"> {{ item.title }}</span>
                        <span v-else class="title title3 slh_s"> {{ item.title }}</span>
                    </div>
                    <div class="info clearfix">
                        <div class="shop_name f-l slh_s">{{ tradesman.nickname }}</div>
                        <div class="source f-r">{{ item.place }}</div>
                    </div>
                    <div class="info">
                        <span class="f-l price">¥{{ item.prices }}</span>
                    </div>
                </div>
            </li>
        </ul>
    </div> -->
    <!-- 项目评论 -->
    <!-- <div class="comment">
        <div class="title">
            项目评论
            <span class="comment_num">{{ "(" + comments_num + ")" }}</span>
        </div>
        <div class="comment_none" v-if="comments_num == 0">暂无评论，把你想说的评论出来吧～</div>
        <div class="">
            <div class="con" v-for="item in comments" :key="item.id">
                <div class="con_top clearfix" v-if="item.user">
                    <div class="f-l thumb">
                        <img :src="item.user.userdata.thumb ? item.user.userdata.thumb : $publicData.defaultTouxiang" alt="" class="thumb" />
                    </div>
                    <div class="f-l con_top_r">
                        <span class="user_name">{{ item.user.userdata.nickname }}</span>
                        <span class="time">{{ item.created_at }}</span>
                    </div>
                </div>
                <div class="con_nr">
                    <div class="yiji_txt">{{ item.comment }}</div>
					<div class="yiji_tu" v-if="item.attrShow">
                        <div class="tu_wrap" v-for="(imgTu, index) in item.images_hide ? item.imagesSlice : item.attrShow" :key="index" @click="zhanshitupian(item,item.images_hide ? item.imagesSlice : item.attrShow,index,id)">
                            <van-image :show-error="false" :show-loading="false" class="image" fit="cover" :src="imgTu" />
                            <div class="mark" v-if="item.images_hide && index == 2">{{'+'+ (item.attrShow.length -3)}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="loadmore" v-if="comments_num > 2" @click="loadMoreFun">
            <span class="txt" v-if="show_moreComment">加载更多</span>
        </div>
        <div class="pinglun" @click="commentFun(dataList.id)">评论</div>
    </div> -->
    <!-- 大图预览 -->
    <van-image-preview v-model="bigTuShow" :start-position="bigTuIndex" :images="bigTuImgArr" @change="bigTuChange"></van-image-preview>
</div>
</template>

<script>
import router from "../../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../../.././vuex/mutation_types";

import Vue from "vue";
import Bridge from "../../../../.././vuex/bridge.js";
Vue.prototype.$bridge = Bridge;
var userAgent = navigator.userAgent;

export default {
    // name: "map-index",
    data() {
        return {
            id: this.$route.query.id, // 项目id
            publicPath: process.env.BASE_URL,
            show_more: false, // 是否显示更多,内容介绍
            dataList: null, // 接口数据
            tradesman: null, // 匠人数据
            comments: [], // 评论数据,多于2条取前两条,加载更多时显示全部评论 comments_total
            comments_total: [], // 项目总评论
            comments_num: 0, // 项目总评论条数
            item: null,
            goods: null,
            show_moreComment: true,
            jieshao: '', // 介绍
            show_more_tu: false, // 加载更多图片，大于3张为真
            bigTuShow: false, // 大图预览
            bigTuIndex: 0, // 
            bigTuImgArr: null,
            token: '',
            shareConfig: null // 分享的相关配置
        };
    },
    created: function () {
        console.log('uploadImage')
        console.log(Vue.prototype.$publicData.uploadImage)
        // 获取列表

        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            var params = {
                'data': {
                    'naviTitle': '项目详情'
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

            })
            //获取用户信息
            var memberParams = {
                'data': {
                    'notCallLogin': 1,
                }
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                if (data.code == 200) {
                    this.token = data.result.token

                } else {
                    this.token = ''
                }
                this.getData();
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback(data)
            })
        } else {
            // 获取列表
            this.token = this.$store.getters.token
            this.getData();
        }
        // console.log(this.$refs.marker)
    },
    methods: {
        // 获取列表
        getData() {
            var params = {
                token: this.token,
                id: this.id
            };
            console.log(params);
            this.$api.map.itemDetail(params).then(res => {
                if (res.code == 200) {
                    // 调起 微信分享的参数
                    // this.getShareData()
                    // console.log(res);
                    this.dataList = res.result;
					this.item = res.result.item;
                    // this.tradesman = res.result.tradesman;
                    // var goods = res.result.goods;
                    // this.goods = goods.length > 0 ? goods : null;
                    // var arr = new Array();
                    // arr = res.result.comments;
                    // this.comments_num = arr.length;
                    // this.comments_total = res.result.comments;
                    // if (this.comments_num > 2) {
                    //     this.comments = this.comments_total.slice(0, 2);
                    // } else {
                    //     this.comments = this.comments_total;
					// }
					// 多张评论图片
					// if(this.comments.length != 0){
					// 	var commentsArr = this.comments
					// 	for(var i in commentsArr ){
					// 		var imagesArr = commentsArr[i].attrShow
					// 		if(imagesArr && imagesArr.length > 3){
					// 			commentsArr[i].images_hide = 1
					// 			commentsArr[i].imagesSlice = imagesArr.slice(0,3)
					// 		}else{
					// 			commentsArr[i].images_hide = 0
					// 		}
					// 	}
					// }
                    // this.cate = res.result.item.cate;
					// this.level = res.result.item.level;
					// console.log('项目点富文本',res.result.item.content)
                    // $(this.$refs.jieshao).html(res.result.item.content);
                    // var docEl = document.documentElement;
                    // 判断内容区是否全部显示
                    // var rem = docEl.clientWidth > 750 ? 75 : docEl.clientWidth / 10;
                    // console.log($(this.$refs.jieshao).innerHeight() / rem);
                    // console.log(this.dataList);
                    // if ($(this.$refs.jieshao).innerHeight() / rem > 5) {
                    //     this.show_more = false;
                    //     $(this.$refs.jieshao).css({
                    //         height: "8rem",
                    //         overflow: "hidden"
                    //     });
                    // } else {
                    //     this.show_more = true;
                    //     $(this.$refs.jieshao).css("height", "auto");
                    // }
                }
            });
        },
        toNewWeb() {
            if (this.item.web_url && this.item.web_url != undefined && this.item.web_url != '') {
                window.open(this.item.web_url)
            }
        },
        // 加载更多
        // loadMore() {
        //     this.show_more = true;
        //     $(this.$refs.jieshao).css("height", "auto");
        // },
        // // 关注匠人
        // guanzhuFun(status, id) {
        //     if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
        //         //获取用户信息
        //         var memberParams = {
        //             'data': {}
        //         }
        //         this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
        //             if (data.code == 200) {
        //                 this.token = data.result.token
        //                 var params = {
        //                     token: this.token,
        //                     tradesman_id: id,
        //                     type: 1
        //                 };
        //                 console.log('params', params)
        //                 this.$api.tradesman.attention(params).then(res => {
        //                     if (res.code == 200) {
        //                         console.log(res)
        //                         this.dataList.isattention = 1
        //                         this.$toast("关注匠人成功");
        //                     }
        //                 })
        //             }
        //         })
        //     } else {
        //         // 验证是否关注
        //         if (status == 1) {
        //             return;
        //         } else {
        //             var params = {
        //                 token: this.token,
        //                 tradesman_id: id,
        //                 type: 1
        //             };
        //             console.log('params', params)
        //             this.$api.tradesman.attention(params).then(res => {
        //                 if (res.code == 200) {
        //                     console.log(res)
        //                     this.dataList.isattention = 1
        //                     this.$toast("关注匠人成功");
        //                 }
        //             })
        //             // localStorage.setItem('redirect', this.$router.currentRoute.fullPath)
        //         }
        //     }
        // },
        // 加载更多评论
        // loadMoreFun() {
        //     console.log("加载更多");
        //     this.comments = this.comments_total;
        //     this.show_moreComment = !this.show_moreComment
        // },
        // 报错
        // baocuoFun(shopid) {
        //     if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
        //         //获取用户信息
        //         var memberParams = {
        //             'data': {}
        //         }
        //         this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
        //             if (data.code == 200) {
        //                 this.$router.push({
        //                     path: "/item/baocuo",
        //                     query: {
        //                         shopid: shopid
        //                     }
        //                 });
        //             }
        //         })
        //     } else {
        //         // 检验是否登录
        //         if (!this.$store.getters.token) {
        //             localStorage.setItem('redirect', this.$router.currentRoute.fullPath)
        //             this.$router.push({
        //                 path: '/login'
        //             })
        //             return
        //         }
        //         this.$router.push({
        //             path: "/item/baocuo",
        //             query: {
        //                 shopid: shopid
        //             }
        //         });
        //     }
        // },
        // 评论
        // commentFun(id) {
        //     if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
        //         //获取用户信息
        //         var memberParams = {
        //             'data': {}
        //         }
        //         this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
        //             if (data.code == 200) {
        //                 this.$router.push({
        //                     path: "/item/comment",
        //                     query: {
        //                         location_id: id
        //                     }
        //                 });
        //             }
        //         })
        //     } else {
        //         // 检验是否登录
        //         if (!this.$store.getters.token) {
        //             localStorage.setItem('redirect', this.$router.currentRoute.fullPath)
        //             this.$router.push({
        //                 path: '/login'
        //             })
        //             return
        //         }
        //         this.$router.push({
        //             path: "/item/comment",
        //             query: {
        //                 location_id: id
        //             }
        //         });
        //     }
        // },
        // 商品详情页
        // goShopDetail(goods) {
        //     if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
        //         var p = "?goodsId=" + goods.id;
        //         var params = {
        //             data: {
        //                 url: this.$publicData.clientUrl + "/shop/detail" + p
        //             },
        //         };
        //         this.$bridge.callhandler(
        //             "sdjy://public/openNewWebView",
        //             params,
        //             (data) => {}
        //         );
        //     } else {
        //         this.$router.push({
        //             path: "/shop/detail",
        //             query: {
        //                 goodsId: goods.id,
        //             },
        //         });
        //     }
        // },
        // 展开大图   其中status用于判断 多于3张的图片，点击第3张加载更多，0 / 1 用于控制show_more_tu
        // zhanshitupian(status, arr, index) {
        //     console.log('点击放大图')
        //     if (status == 1 && index == 2) {
        //         this.show_more_tu = true
        //         return;
        //     } else {
        //         this.bigTuImgArr = arr;
        //         this.bigTuIndex = 0;
        //         this.bigTuShow = true;
        //     }
		// },
		zhanshitupian(item, arr, index) {
			// console.log('点击第几张',index,arr)
			if(index == 2 && item.images_hide){
				for( var i in this.comments){
					if(this.comments[i].id == item.id){
						console.log('2')
						this.comments[i].images_hide = 0
						console.log(this.comments[i])
					}
				}
				// console.log(this.comments)
				// console.log(item)
				return
			}
			
			this.bigTuImgArr = arr;
			this.bigTuIndex = index;
			this.bigTuShow = true;
        },
        // 切换大图
        bigTuChange(index) {
            this.bigTuIndex = index
		},
		// 去匠人页面
		toTradesman(id){
			if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var params = {
                    'data': {
                        'url': this.$publicData.clientUrl + '/art/detail?tradesmanId=' + id
                    }
                }
                this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                })
            } else {
                this.$router.push({
                    path: '/art/detail',
                    query: {
                        tradesmanId: id
                    }
                })
            }
		},
        // 获取分享参数 -- 用于配微信分享
        getShareData() {
            const url = location.href.split('#')[0];
            console.log('url', url)
            this.$api.index.commonShare({
                url: url
            }).then(res => {
                if (res.code == 200) {
                    this.shareConfig = res.result
                    // console.log('this.shareConfig', this.shareConfig)
                    // console.log('this.$route', this.$route)
                    this.shareFun()
                }
            })
        },
        // 分享
        shareFun() {
            var that = this
            wx.config({
                debug: that.shareConfig.debug,
                beta: that.shareConfig.beta,
                jsApiList: that.shareConfig.jsApiList,
                appId: that.shareConfig.appId,
                nonceStr: that.shareConfig.nonceStr, // 随机串
                timestamp: parseInt(that.shareConfig.timestamp), // 时间戳
                signature: that.shareConfig.signature // 签名
            });
            // 分享
            wx.ready(function () {
                const url = location.href.split('#')[0];
                var shareData = {
                    title: that.item.title, // 分享标题
                    desc: that.item.describe, // 分享描述
                    link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: that.$publicData.domain + that.item.thumb, // 分享图标
                    success: function () {
                        // 用户确认分享后执行的回调函数
                        // alert('成功')
                    },
                    cancel: function (e) {
                        // alert(e)
                        // 用户取消分享后执行的回调函数
                    }
                }
                wx.updateAppMessageShareData(shareData);
                wx.updateTimelineShareData(shareData);
            });
        }
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>

/deep/.van-image__img {
    border-radius: .134rem !important;
}
</style>
